import type { ConfigMap } from '@memorang/constants/config/schema';

export const customConstants: ConfigMap = {
  "therapyed": {
    "id": "therapyed",
    "tenant": {
      "id": "53d94851-4af6-4dfc-943d-92929b3e9dcc",
      "name": "TherapyEd"
    },
    "supportEmail": "info@therapyed.com",
    "companyName": "TherapyEd",
    "app": {
      "id": "db878dfd-9617-456b-b458-14902e06462f",
      "name": "TherapyEd",
      "template": "testprep",
      "proficiencyTargetScore": 90,
      "maxScaledScore": 100,
      "scheme": "therapyed.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1590041414"
        },
        "android": {
          "versionCode": 105,
          "package": "com.memorang.therapyed",
          "googleServicesJson": "73a57898-161a-4aa1-837f-e0ba27222a26",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.therapyed",
          "buildNumberState": {
            "currentVersion": "2.1.40",
            "buildNumber": 2
          }
        }
      },
      "version": "2.1.44",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "https://apps.apple.com/us/app/therapyed/id1590041414",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.therapyed"
        },
        "subtitle": "We are currently making improvements to enhance your experience. TherapyEd app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "opensans",
      "trademark": "TherapyEd",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "hideTotalItemCounts": false,
      "fontSizes": {
        "stem": 18,
        "answer": 18,
        "explanation": 14
      },
      "analytics": {
        "mixpanel": {
          "id": "5b3fe7e0378f1a1bd87bc085ddc9b66e"
        }
      },
      "logo": {
        "icon": "https://icon.memorang.com/app-resources/therapyed/ios/icon.png",
        "adaptiveIcon": "https://icon.memorang.com/app-resources/therapyed/android/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.therapyed.com",
        "privacy": "https://app.therapyed.com/legal/privacy",
        "tos": "https://app.therapyed.com/legal/terms",
        "redeemSupportUrl": "https://therapyed.zendesk.com/hc/en-us/articles/6864418376468-How-can-I-redeem-access-to-my-purchased-content-",
        "companyUrl": "https://www.therapyed.com/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_LCnNlSXwMCLCGLQsftcakAoejTs",
          "android": "goog_cFBRaPbCakxtxjBbmsUDprlTzfN"
        },
        "oneSignalAppId": "ac799c9b-47da-4692-b722-ce25feffc4ca",
        "clerk": {
          "publishableKeyDev": "pk_test_ZnJlZS1sZW9wYXJkLTExLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRoZXJhcHllZC5jb20k"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-therapyed-shared"
        }
      },
      "supportUrl": "https://therapyed.zendesk.com/hc/en-us",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "TherapyEd AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/icons/therapyed/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning agent, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TherapyEd Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TherapyEd team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/therapyed/therapyed/aibl/landing_graphic.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showDurationSelection": false,
        "showLearningMode": true,
        "crossTagSelection": true,
        "maxFilterDepth": 1,
        "hideRecommendedTab": false
      },
      "accountSettings": {
        "showPurchasedProducts": true,
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_AgaYogapqc46ya3SAueL81FmZUGG",
            "deployedAt": "2026-08-20T14:11:45.057Z",
            "version": "2.1.44"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      },
      "i18n": {
        "supportedLocales": [
          "en-US"
        ],
        "fallbackLocale": "en-US",
        "defaultToDeviceLocale": true,
        "overrides": {}
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "allowChangeExamDate": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      }
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domains",
      "showRedeem": false,
      "headerIconMode": "exam"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "scoreDisplayMode": "raw",
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "options": {
        "showProficiencyEstimates": false,
        "fillPreviousProficiencyLevels": true
      },
      "ai": {
        "sessionAnalysis": true,
        "sessionInsights": false
      },
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "isMobile": true,
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "data": [
          {
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "icon": "shield-check-outline"
          },
          {
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "icon": "lock-outline"
          },
          {
            "titlei18n": {
              "en-US": "You control your data"
            },
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "icon": "account-cog-outline"
          },
          {
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam"
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "titlei18n": {
          "en-US": "Choose your Exam Date"
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      },
      "hideStudyPack": false
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "testDriver": "default",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "allowMarking": true,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      },
      "ai": {
        "hint": true,
        "aila": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(140, 145, 153)",
          "primary": "rgb(255, 180, 163)",
          "surface": "rgb(40, 42, 44)",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(214, 190, 228)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(51, 49, 50)",
            "level2": "rgb(57, 53, 54)",
            "level3": "rgb(64, 57, 57)",
            "level4": "rgb(66, 59, 58)",
            "level5": "rgb(70, 61, 61)"
          },
          "onPrimary": "rgb(99, 16, 0)",
          "onSurface": "rgb(226, 226, 230)",
          "secondary": "rgb(157, 202, 255)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(58, 42, 72)",
          "onSecondary": "rgb(0, 50, 87)",
          "onBackground": "rgb(226, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(171, 53, 26)",
          "inverseSurface": "rgb(226, 226, 230)",
          "outlineVariant": "rgb(66, 71, 78)",
          "surfaceVariant": "rgb(66, 71, 78)",
          "surfaceDisabled": "rgba(226, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(194, 199, 207)",
          "primaryContainer": "rgb(137, 29, 3)",
          "onSurfaceDisabled": "rgba(226, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(82, 64, 95)",
          "onPrimaryContainer": "rgb(255, 218, 210)",
          "secondaryContainer": "rgb(0, 73, 123)",
          "onTertiaryContainer": "rgb(242, 218, 255)",
          "onSecondaryContainer": "rgb(208, 228, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 111)",
          "primary": "#ab351a",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(59, 45, 42, 0.4)",
          "tertiary": "rgb(106, 87, 120)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(255, 255, 255)",
            "level2": "rgb(255, 255, 255)",
            "level3": "rgb(255, 255, 255)",
            "level4": "rgb(255, 255, 255)",
            "level5": "rgb(255, 255, 255)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 25)",
          "secondary": "rgb(0, 98, 162)",
          "background": "#f2f2f2",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 25)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 180, 163)",
          "inverseSurface": "rgb(54, 47, 45)",
          "outlineVariant": "rgb(216, 194, 189)",
          "surfaceVariant": "rgb(245, 221, 216)",
          "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 235)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 64)",
          "primaryContainer": "rgb(255, 218, 210)",
          "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
          "tertiaryContainer": "rgb(242, 218, 255)",
          "onPrimaryContainer": "rgb(61, 6, 0)",
          "secondaryContainer": "rgb(209, 228, 255)",
          "onTertiaryContainer": "rgb(37, 20, 50)",
          "onSecondaryContainer": "rgb(0, 29, 53)"
        }
      },
      "roundness": 4
    },
    "createdAt": "2024-05-22 13:42:54.667397+00",
    "updatedAt": "2026-08-20 14:11:45.093135+00"
  }
} as unknown as ConfigMap;